"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var strings_1 = require("@/util/strings");
var forms_1 = require("@/util/forms");
/**
 * This implements MessageHandler interface
 * @param message
 * @param value
 */
function default_1(message, value) {
    value.eventContent = 'Form';
    return message.name === 'FormError' ? generateFormErrorEvent(message, value) : generateInteractionFormEvent(message, value);
}
exports.default = default_1;
;
var generateInteractionFormEvent = function (message, value) {
    value.eventType = message.name || '';
    value.eventFormVendor = message.vendor || '';
    value.eventStepType = (message.pageFinal ? 'final' : '') + (0, strings_1.upperFirst)(message.pageRole || '');
    value.eventElementType = (0, forms_1.mapElementName)(message.event);
    value.eventFieldNumber = message.fieldNumber || 0;
    if (message.context) {
        value.eventContext = message.context;
    }
    if (message.datapath) {
        var elementName = message.subpath && message.subpath.length > 0
            ? message.datapath + ':' + message.subpath.reverse().join('.')
            : message.datapath;
        if (!message.context) {
            value.eventContext = elementName;
        }
        value.eventElementName = elementName;
    }
    if (message.page) {
        value.eventStep = message.page;
    }
    if (message.form) {
        value = __assign(__assign({}, value), generateFormMetas(message.form));
    }
    value.eventValue = ('' + message.value) || '';
    value.eventTimestamp = Date.now();
    value.eventSession = message.session || '';
    return value;
};
var generateFormErrorEvent = function (message, value) {
    value.eventContext = 'Form Error';
    value.eventValue = 'Load Error';
    value.eventContent = message.label || '';
    value.eventType = message.name || '';
    value.eventFormVendor = message.vendor || '';
    value.eventType = message.name || '';
    value.eventFormVendor = message.vendor || '';
    if (message.context) {
        value.eventContext = message.context;
    }
    if (message.form) {
        value = __assign(__assign({}, value), generateFormMetas(message.form));
    }
    value.eventTimestamp = Date.now();
    value.eventSession = message.session || '';
    return value;
};
var generateFormMetas = function (form) { return ({
    eventFormDesign: form.view || '',
    eventFormName: form.name || '',
    eventFormVersion: form.version || ''
}); };
